export enum ViewPort {
  DESKTOP = 'deskTop',
  MOBILE = 'mobile',
}
const WEBSITE_NAME = process.env.NEXT_PUBLIC_CAN_USE_OFFICIAL_NAME ? 'Canary Mission' : `Türkiye Mission`;

export const CANARY_MISSION = {
  NAME: WEBSITE_NAME,
  BASIC_URL: 'https://canarymission.org',
  X_TWITTER: '@canarymission',
  KEYWORDS: `${WEBSITE_NAME}, BDS, Anti-Semitism, Hatred`,
  DEFAULT_LOGO: 'https://cm2cdn.canarymission.org/static/images/canarymission_logo_grey_backgroud.jpg',
  MAIN_DESCRIPTION: `${WEBSITE_NAME} documents people and groups that promote hatred of the USA, Israel and Jews on North American college campuses`,
  INVESTIGATION_DESCRIPTION_SHORT: `${WEBSITE_NAME} investigates hatred on the far-right, far-left and by anti-Israel activists.`,
  INVESTIGATION_DESCRIPTION_LONG: `${WEBSITE_NAME} investigates hatred across the entire political spectrum, including the far right, far left and anti-Israel activists.`,
  CAREFULLY_RESEARCHED_TEXT_SHORT: `profile has been carefully researched and sourced.`,
  CAREFULLY_RESEARCHED_TEXT_LONG: `on the ${WEBSITE_NAME} database has been carefully researched. All information is gathered from publicly available sources.`
} as const;
